
// Get the element that will trigger the toggle
const triggerElement = document.getElementById('call-event');

// Add an event listener to the trigger element
triggerElement.addEventListener('click', function() {
  // Get the div element with the specific class name
  const targetDiv = document.querySelector('.phone-slide');

  // Toggle the class on the target div element
  targetDiv.classList.toggle('slideFromRight');
});